/**
 * Pont activité réseau → idle timer (hors React / httpClient).
 * Émis après une réponse API authentifiée 2xx pour remettre le chrono d’inactivité.
 */
export const SESSION_ACTIVITY_EVENT = 'cse:session-activity'

export function emitSessionActivity(): void {
  if (typeof window === 'undefined') {
    return
  }
  window.dispatchEvent(new CustomEvent(SESSION_ACTIVITY_EVENT))
}

export function onSessionActivity(handler: () => void): () => void {
  window.addEventListener(SESSION_ACTIVITY_EVENT, handler)
  return () => window.removeEventListener(SESSION_ACTIVITY_EVENT, handler)
}

/** Paths that must not reset idle (public / auth bootstrap). */
export function isSessionActivityExemptPath(path: string): boolean {
  const normalized = path.split('?')[0] ?? path
  if (normalized.includes('/sanctum/')) {
    return true
  }
  if (
    normalized.includes('/auth/login') ||
    normalized.includes('/auth/register') ||
    normalized.includes('/auth/forgot-password') ||
    normalized.includes('/auth/reset-password') ||
    normalized.includes('/auth/magic-link') ||
    normalized.includes('/auth/impersonate') ||
    normalized.includes('/auth/accept-invitation') ||
    // Keep-alive's own ping must never count as activity - feedback loop otherwise.
    normalized.includes('/auth/refresh') ||
    normalized.includes('/auth/logout')
  ) {
    return true
  }
  if (
    normalized.includes('/api/v1/brand') ||
    normalized.includes('/api/v1/feature-flags') ||
    normalized.includes('/api/v1/payments/config') ||
    normalized.includes('/api/v1/maintenance') ||
    normalized.includes('/api/v1/public/reservation-hub') ||
    normalized.includes('/legal/')
  ) {
    return true
  }
  // Background polls (header cart badge, waiting queue, drop rooms) - not user activity.
  if (
    normalized.includes('/api/v1/cart') ||
    normalized.includes('/api/v1/drop-rooms/active') ||
    normalized.includes('/api/v1/reservations/waiting-queue/status')
  ) {
    return true
  }
  return false
}
